import styled from '@emotion/styled'

import { ReportIcon, SafeIcon, CompliantIcon, DataIcon, BusinessIcon } from '@segment/matcha/components/Icons/Brandbook'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import IconWrapper from '@segment/matcha/components/IconWrapper'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  heading: `Our Privacy Policy honors CCPA and GDPR`,
  description: `We take the responsibility of respecting privacy seriously. Here are a few initiatives Segment is committed to:`,
}

const links = {
  dataProcessingUrl: `https://segment.com/docs/privacy/complying-with-the-gdpr/#opting-into-the-data-processing-agreement-and-standard-contractual-clauses`,
  dataTransferUrl: `https://www.twilio.com/en-us/legal/privacy/#international-data-transfers`,
  bindingCorpRulesUrl: `https://www.twilio.com/en-us/legal/bcr/`,
}

const boxes = [
  {
    icon: <DataIcon />,
    title: `Data Processing Agreement`,
    description: `Our <a href="${links.dataProcessingUrl}">Data Processing Agreement (DPA)</a> reflects the requirements of the GDPR.`,
  },
  {
    icon: <BusinessIcon />,
    title: `Data Transfer Practices`,
    description: `Twilio is certified under the <a href="${links.dataTransferUrl}">EU-US DPF and Swiss-US DPF</a> and offer <a href="${links.bindingCorpRulesUrl}">BCR’s</a> and SCC’s for transfers of your data outside the EU.`,
  },
  {
    icon: <SafeIcon />,
    title: `Privacy by Design`,
    description: `Your data is yours to own. Segment does not sell our customers' user data.`,
  },
  {
    icon: <ReportIcon />,
    title: `Privacy Policy`,
    description: `Our Privacy Policy honors CCPA, the GDPR, the Privacy Shield Framework.`,
  },
  {
    icon: <CompliantIcon />,
    title: `Data Protection Officer`,
    description: `Segment has appointed a Data Protection Officer to oversee our ongoing compliance efforts.`,
  },
]

const SegmentCommitment = () => {
  return (
    <SectionBaseWrapper variant="centered">
      <Section.Copy>
        <CopyTextBaseWrapper centered={true}>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pLarge" tag="p">
            {copy.description}
          </CopyText.Description>
        </CopyTextBaseWrapper>
      </Section.Copy>
      <Section.Contents>
        <StyledColumnTrack columns={1} overrides={{ md: 3 }}>
          {boxes.map(({ icon, title, description }) => (
            <FeatureBoxBase key={title} alignment="left" headerPosition="top">
              <FeatureBox.Header>
                <IconWrapper appearance="twilioLight" variant="circle" elevation={1}>
                  {icon}
                </IconWrapper>
              </FeatureBox.Header>
              <FeatureBox.Body>
                <FeatureBox.Title>{title}</FeatureBox.Title>
                <FeatureBox.Text tag="div">
                  <p dangerouslySetInnerHTML={{ __html: description }}></p>
                </FeatureBox.Text>
              </FeatureBox.Body>
            </FeatureBoxBase>
          ))}
        </StyledColumnTrack>
      </Section.Contents>
    </SectionBaseWrapper>
  )
}

const SectionBaseWrapper = styled(SectionBase)`
  padding-top: 60px;
  max-width: 1280px;

  ${Section.Wrapper} {
    row-gap: 56px;
  }
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding-top: 80px;
  }
`

const CopyTextBaseWrapper = styled(CopyTextBase)`
  text-align: left;
  padding-bottom: 20px;
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    max-width: 844px;
    text-align: center;
    padding-bottom: 0;
  }
`

const StyledColumnTrack = styled(ColumnTrack)`
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    row-gap: 80px;
  }
`

export default SegmentCommitment
